import Tooltip__SvelteComponent_ from "@components/utilities/Tooltip.svelte"

const mouseLocation = { x: 0, y: 0 }
const update = (evt: PointerEvent) => {
    ;(mouseLocation.x = evt.clientX), (mouseLocation.y = evt.clientY)
}
document.addEventListener("pointerdown", update)
document.addEventListener("pointermove", update)

export function tooltip(msg: string, mouse = true, burst = true) {
    const location = {
        x: mouse ? mouseLocation.x : window.innerWidth / 2,
        y: mouse ? mouseLocation.y : window.innerHeight / 2,
    }
    const tooltip = new Tooltip__SvelteComponent_({
        target: window.document.body,
        props: {
            msg,
            location,
            burst,
        },
    })

    setTimeout(tooltip.$destroy, 2000)
}

export function burst() {
    tooltip("", true, true)
}
